import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IFido2ConfigurePayload, IFido2Payload, IFriendlyNamePayload } from '../model/fido2.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiFido2Service {
  constructor(private http: HttpClient) {}

  _initiateFido2 = (trackId: string, method: string) => {
    return this.http.post<any>(`${environment.base_url}/verification-actions-srv/setup/${method}/initiate/${trackId}`, {});
  };

  _configureFido2 = (payload: IFido2ConfigurePayload, method: string) => {
    return this.http.post<any>(`${environment.base_url}/verification-actions-srv/setup/${method}/verification`, payload);
  };

  _configureFido2Name = (payload: IFriendlyNamePayload, track_id:string, method:string) => {
    return this.http.put<any>(`${environment.base_url}/verification-actions-srv/setup/users/friendlyname/${method}/${track_id}`, payload);
  };
}
